(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlinx-serialization-kotlinx-serialization-json.js', './curity-ssi-libs-jose.js', './kotlin-kotlin-stdlib.js', './kotlinx-serialization-kotlinx-serialization-core.js', './curity-ssi-libs-did.js', './curity-ssi-libs-core-json.js', './curity-ssi-libs-did-json.js', './curity-ssi-libs-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlinx-serialization-kotlinx-serialization-json.js'), require('./curity-ssi-libs-jose.js'), require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./curity-ssi-libs-did.js'), require('./curity-ssi-libs-core-json.js'), require('./curity-ssi-libs-did-json.js'), require('./curity-ssi-libs-core.js'));
  else {
    if (typeof this['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-did-resolvers-jwk'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json' is loaded prior to 'curity-ssi-libs-did-resolvers-jwk'.");
    }
    if (typeof this['curity-ssi-libs-jose'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-did-resolvers-jwk'. Its dependency 'curity-ssi-libs-jose' was not found. Please, check whether 'curity-ssi-libs-jose' is loaded prior to 'curity-ssi-libs-did-resolvers-jwk'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-did-resolvers-jwk'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'curity-ssi-libs-did-resolvers-jwk'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-did-resolvers-jwk'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'curity-ssi-libs-did-resolvers-jwk'.");
    }
    if (typeof this['curity-ssi-libs-did'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-did-resolvers-jwk'. Its dependency 'curity-ssi-libs-did' was not found. Please, check whether 'curity-ssi-libs-did' is loaded prior to 'curity-ssi-libs-did-resolvers-jwk'.");
    }
    if (typeof this['curity-ssi-libs-core-json'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-did-resolvers-jwk'. Its dependency 'curity-ssi-libs-core-json' was not found. Please, check whether 'curity-ssi-libs-core-json' is loaded prior to 'curity-ssi-libs-did-resolvers-jwk'.");
    }
    if (typeof this['curity-ssi-libs-did-json'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-did-resolvers-jwk'. Its dependency 'curity-ssi-libs-did-json' was not found. Please, check whether 'curity-ssi-libs-did-json' is loaded prior to 'curity-ssi-libs-did-resolvers-jwk'.");
    }
    if (typeof this['curity-ssi-libs-core'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-did-resolvers-jwk'. Its dependency 'curity-ssi-libs-core' was not found. Please, check whether 'curity-ssi-libs-core' is loaded prior to 'curity-ssi-libs-did-resolvers-jwk'.");
    }
    root['curity-ssi-libs-did-resolvers-jwk'] = factory(typeof this['curity-ssi-libs-did-resolvers-jwk'] === 'undefined' ? {} : this['curity-ssi-libs-did-resolvers-jwk'], this['kotlinx-serialization-kotlinx-serialization-json'], this['curity-ssi-libs-jose'], this['kotlin-kotlin-stdlib'], this['kotlinx-serialization-kotlinx-serialization-core'], this['curity-ssi-libs-did'], this['curity-ssi-libs-core-json'], this['curity-ssi-libs-did-json'], this['curity-ssi-libs-core']);
  }
}(globalThis, function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_io_curity_ssi_jose, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_io_curity_ssi_did, kotlin_io_curity_ssi_core_json, kotlin_io_curity_ssi_did_json, kotlin_io_curity_ssi_core) {
  'use strict';
  //region block: imports
  var Default_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
  var JsonJwk = kotlin_io_curity_ssi_jose.$_$.r;
  var getKClass = kotlin_kotlin.$_$.e;
  var arrayOf = kotlin_kotlin.$_$.hf;
  var createKType = kotlin_kotlin.$_$.b;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t2;
  var THROW_CCE = kotlin_kotlin.$_$.te;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
  var isInterface = kotlin_kotlin.$_$.xa;
  var encodeToByteArray = kotlin_kotlin.$_$.nc;
  var encodeBase64url = kotlin_io_curity_ssi_jose.$_$.o;
  var Did = kotlin_io_curity_ssi_did.$_$.f;
  var VOID = kotlin_kotlin.$_$.f;
  var DidUrl = kotlin_io_curity_ssi_did.$_$.e;
  var protoOf = kotlin_kotlin.$_$.kb;
  var initMetadataForObject = kotlin_kotlin.$_$.oa;
  var toSet = kotlin_kotlin.$_$.r8;
  var decodeBase64Url = kotlin_io_curity_ssi_jose.$_$.n;
  var decodeToString = kotlin_kotlin.$_$.mc;
  var DidResolutionException = kotlin_io_curity_ssi_did.$_$.d;
  var Exception = kotlin_kotlin.$_$.ke;
  var JsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.i;
  var SerializationException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n2;
  var DefaultJsonMultiValue_init_$Create$ = kotlin_io_curity_ssi_core_json.$_$.b;
  var JsonPublicKeyJwk = kotlin_io_curity_ssi_did_json.$_$.d;
  var JsonVerificationMethod = kotlin_io_curity_ssi_did_json.$_$.e;
  var JsonDidDocument = kotlin_io_curity_ssi_did_json.$_$.b;
  var JsonDidResolutionSuccessResult = kotlin_io_curity_ssi_did_json.$_$.c;
  var initMetadataForClass = kotlin_kotlin.$_$.ia;
  var enumEntries = kotlin_kotlin.$_$.p9;
  var Unit_instance = kotlin_kotlin.$_$.h5;
  var Enum = kotlin_kotlin.$_$.ie;
  var ToString = kotlin_io_curity_ssi_core.$_$.m;
  //endregion
  //region block: pre-declaration
  initMetadataForObject(JwkDid, 'JwkDid');
  initMetadataForClass(JwkDidResolver, 'JwkDidResolver', JwkDidResolver, VOID, VOID, [1]);
  initMetadataForClass(JwkDidType, 'JwkDidType', VOID, Enum, [ToString, Enum]);
  initMetadataForClass(VerificationMethodType, 'VerificationMethodType', VOID, Enum, [ToString, Enum]);
  //endregion
  function JwkDid() {
  }
  protoOf(JwkDid).w3l = function (verificationKey) {
    var tmp = JwkDidType_JWK_getInstance().toString();
    // Inline function 'kotlinx.serialization.encodeToString' call
    var this_0 = Default_getInstance();
    var value = verificationKey.u2f();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.dp();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(JsonJwk), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var tmp$ret$2 = this_0.bp(tmp$ret$1, value);
    return new DidUrl(new Did(tmp, encodeBase64url(encodeToByteArray(tmp$ret$2))), VOID, VOID, '0');
  };
  var JwkDid_instance;
  function JwkDid_getInstance() {
    return JwkDid_instance;
  }
  function JwkDidResolver() {
    this.x3l_1 = toSet(get_entries());
  }
  protoOf(JwkDidResolver).y3l = function (did, $completion) {
    var id = did.k2i_1;
    var tmp;
    try {
      tmp = decodeToString(decodeBase64Url(id));
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Exception) {
        var ex = $p;
        throw new DidResolutionException('DID identifier is not base64 url');
      } else {
        throw $p;
      }
    }
    var jwkString = tmp;
    var jwk;
    try {
      var element = Default_getInstance().c19(jwkString);
      if (!(element instanceof JsonObject)) {
        throw new DidResolutionException('DID Identifier is not valid for DID method');
      }
      jwk = element;
    } catch ($p) {
      if ($p instanceof SerializationException) {
        var ex_0 = $p;
        throw new DidResolutionException('DID Identifier is not valid for DID method', ex_0);
      } else {
        throw $p;
      }
    }
    var tmp0_id = did.m2i('0');
    var tmp1_type = VerificationMethodType_JsonWebKey2020_getInstance();
    var tmp2_controller = DefaultJsonMultiValue_init_$Create$(did);
    var tmp3_publicKeyJwk = new JsonPublicKeyJwk(jwk);
    var didDocument = new JsonDidDocument(did, DefaultJsonMultiValue_init_$Create$(new JsonVerificationMethod(tmp0_id, tmp2_controller, tmp1_type, tmp3_publicKeyJwk)));
    return new JsonDidResolutionSuccessResult(didDocument);
  };
  protoOf(JwkDidResolver).k2j = function (did, $completion) {
    return this.y3l(did, $completion);
  };
  protoOf(JwkDidResolver).o2k = function () {
    return this.x3l_1;
  };
  var JwkDidType_JWK_instance;
  function values() {
    return [JwkDidType_JWK_getInstance()];
  }
  function get_entries() {
    if ($ENTRIES == null)
      $ENTRIES = enumEntries(values());
    return $ENTRIES;
  }
  var JwkDidType_entriesInitialized;
  function JwkDidType_initEntries() {
    if (JwkDidType_entriesInitialized)
      return Unit_instance;
    JwkDidType_entriesInitialized = true;
    JwkDidType_JWK_instance = new JwkDidType('JWK', 0);
  }
  var $ENTRIES;
  function JwkDidType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  protoOf(JwkDidType).toString = function () {
    return 'jwk';
  };
  var VerificationMethodType_JsonWebKey2020_instance;
  var VerificationMethodType_EcdsaSecp256k1VerificationKey2019_instance;
  var VerificationMethodType_entriesInitialized;
  function VerificationMethodType_initEntries() {
    if (VerificationMethodType_entriesInitialized)
      return Unit_instance;
    VerificationMethodType_entriesInitialized = true;
    VerificationMethodType_JsonWebKey2020_instance = new VerificationMethodType('JsonWebKey2020', 0, 'JsonWebKey2020');
    VerificationMethodType_EcdsaSecp256k1VerificationKey2019_instance = new VerificationMethodType('EcdsaSecp256k1VerificationKey2019', 1, 'EcdsaSecp256k1VerificationKey2019');
  }
  function VerificationMethodType(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.b3m_1 = value;
  }
  protoOf(VerificationMethodType).toString = function () {
    return this.p2_1;
  };
  function JwkDidType_JWK_getInstance() {
    JwkDidType_initEntries();
    return JwkDidType_JWK_instance;
  }
  function VerificationMethodType_JsonWebKey2020_getInstance() {
    VerificationMethodType_initEntries();
    return VerificationMethodType_JsonWebKey2020_instance;
  }
  //region block: init
  JwkDid_instance = new JwkDid();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = JwkDid_instance;
  _.$_$.b = JwkDidResolver;
  //endregion
  return _;
}));

//# sourceMappingURL=curity-ssi-libs-did-resolvers-jwk.js.map
